module.exports = __webpack_public_path__ + "static/img/upload.deb8bcd4.png";